<template>
  <div class="container" style="height: calc(100% - 155px)">
    <div style="width: 1260px; margin: 0 auto; display: flex; height: 100%">
      <div class="tab">
        <div class="tab_title">关于</div>
        <!-- <div class="underline"></div> -->
        <ul>
          <!-- <li
            v-for="(item, index) in tab_arr"
            :key="index"
            @click="changeTab(item.index)"
            :class="active_index == item.index ? 'active' : ''"
          >
            <span>{{ item.name }}</span>
          </li> -->
        </ul>
      </div>
      <div class="content" style="height: calc(100% - 90px)">
        <div class="content-txt">
          <div>
             星格量化投资技术研究所(苏州)有限公司，成立于2022年，是上海文华财经资讯股份有限公司的全资子公司，专注于量化软件业务。
          </div>
          <div class="title">
            <common-data name="appShortName_11"/>麦语言
          </div>
          <div>
             麦语言倡导的是积木式的编程理念，把复杂算法封装到一个个的函数里，采用"小语法，大函数"的构建模式，大幅提高编写效率，其他语言100多句的模型，用麦语言一般10几句就可以编出来。配合专门的量化交易数据结构，配合丰富的金融统计函数库，同样可以支持逻辑复杂的金融应用。
          </div>
          <div class="title">
            <common-data name="appShortName_17"/>宽语言
          </div>
          <div>
             宽语言采用类C语言的语法和运行逻辑，编写可以随心所欲，实现各类复杂逻辑的策略开发。可以编译成DLL文件来运行，运行速度更快，达到C语言exe程序的运行速度，足够满足算法交易对运行速度的要求。
          </div>
          <div class="title">
            <common-data name="appShortName_37"/>多因子量化库
          </div>
          <div>
            系统因子库，包含股票因子、可转债因子两大类，共计133个因子。其中，股票因子包含了量价类-技术指标、量价类-波动率因子、财务类-盈利能力等12个类别共计80多个因子；可转债因子包含了市场估值类、量价类、正股财报类、正股量价类4个类别共计40多个因子。该因子库既覆盖了大多数的常见因子，又集成了各大机构研究中的因子研究成果，不断上新中...
          </div>
          <div class="title">
            <common-data name="appShortName_29"/>买方投研
          </div>
          <div>
            是量化交易技术领域的又一个创新实践。
          </div>
          <div>
            股票投资方面，作为多因子估值数据库的量化应用示范平台，支持引用估值数据，以及宏观、市场情绪、财务等各类事件因子，来开发风险控制策略，提供了包括编写因子、可视化策略构建、回测报告等功能。另外，<common-data name="appShortName_29"/>提供实用性的风险控制策略案例。
          </div>
          <div>
            商品CTA方面，支持引用大宗商品的产业大数据，宏观、供给、需求、消费等因子，量化各类市场参与者的决策依据，仿真市场价格的形成机制，对各个商品做多因子分析，构建量化交易策略。
          </div>
          <div>
            <common-data name="appShortName_29"/>也内置了文华的AI大语言模型技术，引用文华财经的行业新闻数据库，AI技术做行情分析，撰写研究报告。
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      // tab_arr: [
      //   {
      //     name: "星格量化研究所",
      //     index: 0,
      //   },
      // ],
      height: 0,
      // active_index: 0,
    };
  },
  methods: {
    changeTab(index) {
      this.active_index = index;
    },
  },
  mounted() {
    this.height = document.body.clientHeight - 201;
  },
};
</script>
<style scoped>
.container {
  padding-top: 50px;
  height: 100%;
  min-height: 400px;
  background: url(https://wh-api.wenhua.com.cn/api/WhBanner/GetWhBannerUrl?id=82)no-repeat top,url(../assets/img/bgonepp.jpg)repeat-y center top 900px;
  text-align: left;
}
.tab {
  width: 144px;
  visibility: hidden;
}
.tab_title {
  font-size: 17px;
  font-weight: 570;
  line-height: 40px;
  padding-left: 8px;
  color: #323232;
}
.underline {
  width: 30px;
  height: 2px;
  background: #323232;
  margin-left: 8px;
}
.tab ul {
  margin-top: 30px;
}
.tab ul li {
  color: rgb(66, 94, 144);
  height: 40px;
  line-height: 40px;
  font-size: 17px;
  width: 160px;
  padding-left: 8px;
  background: transparent;
  cursor: pointer;
  margin-bottom: 10px;
}
.tab ul li.active {
  background-color: rgb(229, 242, 251);
  box-shadow: #d1d6e5 1px 1px 5px 2px;
}
.content {
  color: rgb(132, 133, 135);
  width: 100%;
  height: 100%;
  min-height: 600px;
  background: #f6f9fe;
  box-shadow: -1px 0px 3px 0px rgba(209, 222, 238, 0.9);
  padding: 40px 40px 40px 40px;
  font-size: 16px;
  border-radius: 10px  10px 0 0;
}
.content-txt {
  padding: 0px 30px 40px 30px;
}
.content-txt a {
  color: #5086f5;
}
.content-txt div{
  text-indent: 2em;
  padding: 4px 0;
  line-height: 23px;
}
.title {
  font-weight: bold;
  text-indent: 0;
  margin-top: 15px;
}

</style>